import { Typography } from '@mui/material';

import type { GetReportFileRowsLessMigrationProps } from './types';
import { REMITTANCE_MIGRATION } from '../../constants';
import { getReportFileRows } from '../getReportFileRows';

export const getReportFileRowsLessMigration = ({
  bill,
  fileType,
  fetchState,
}: GetReportFileRowsLessMigrationProps) => {
  const isRemittanceMigration =
    String(bill?.remittence) === REMITTANCE_MIGRATION;

  if (isRemittanceMigration) {
    return <Typography variant="body2">-</Typography>;
  }

  return getReportFileRows(fileType, fetchState);
};
